import { render, staticRenderFns } from "./InboundTransfersPrint.template.vue?vue&type=template&id=7373688b&scoped=true&"
var script = {}
import style0 from "./InboundTransfersPrint.template.vue?vue&type=style&index=0&id=7373688b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7373688b",
  null
  
)

export default component.exports